<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2021-04-19 12:06:46
 * @LastEditTime: 2021-04-22 14:42:52
 * @Description: 
-->
<template>
  <div class="drawer-wrapper">
    <CustomerSearchSidebar />
    <div class="customer-detail-wrap">
      <h1 class="customer-title">{{ customer.name }}</h1>
      <div class="customer-detail">
        <CustomerInfo />
      </div>
    </div>
    <Comment class="comment" />
    <router-view class="content" />
  </div>
</template>

<script>
import { arrayIntersection } from "@/utils";
import { mapActions, mapGetters, mapState } from "vuex";
import CustomerInfo from "./components/CustomerDrawer/CustomerInfo";
import CustomerSearchSidebar from "./components/CustomerDrawer/CustomerSearchSidebar";
import Comment from "@/components/layout/Comment.vue";

export default {
  name: "CustomerDetail",
  components: {
    CustomerInfo,
    CustomerSearchSidebar,
    Comment,
  },
  data() {
    return {
      tableHeight: 300,
    };
  },
  computed: {
    ...mapGetters({}),
    ...mapState({
      user: (state) => state.auth.currentUser,
      userList: (state) => state.user.userList,
      departmentList: (state) => state.department.departmentList,
      customer: (state) => state.customer.selectCustomer,
    }),
  },
  methods: {
    ...mapActions({
      setDetailCustomersId: "customer/setDetailCustomersIdAction",
      selectCustomer: "customer/saveSelectCustomerAction",
      getCustomerById: "customer/getCustomerByIdAction",
    }),
  },
  async created() {
    // this.loadSalesPlanReceive();
    await this.getCustomerById(this.$route.query.id);

    // 保存点击客户ID到state中
    await this.setDetailCustomersId(this.$route.query.id);
    // this.selectCustomer(this.$route.query);
  },
  mounted() {
    // this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    // window.onresize = () => {
    //   this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    // };
    if (this.$route.path === "/home/customer/customer_detail") {
      this.isToDetail = true;
    }
  },
  // destroyed() {
  //   window.onresize = null;
  // },
};
</script>

<style scoped lang="stylus">
.drawer-wrapper
  display flex
  padding 0

.customer-detail
  display flex

.customer-title
  margin-bottom 20px
  display inline-block
  width 1200px
  padding 0 16px

.comment
  width 320px
</style>
